import { render, staticRenderFns } from "./DeleteCommunity.vue?vue&type=template&id=379d0bd6&scoped=true"
import script from "./DeleteCommunity.vue?vue&type=script&lang=js"
export * from "./DeleteCommunity.vue?vue&type=script&lang=js"
import style0 from "./DeleteCommunity.vue?vue&type=style&index=0&id=379d0bd6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379d0bd6",
  null
  
)

export default component.exports